/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SurgicalAppointmentAttribute from './surgical-appointment-attribute';
import SurgicalAppointmentAttributeDetail from './surgical-appointment-attribute-detail';
import SurgicalAppointmentAttributeUpdate from './surgical-appointment-attribute-update';
import SurgicalAppointmentAttributeDeleteDialog from './surgical-appointment-attribute-delete-dialog';

const SurgicalAppointmentAttributeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SurgicalAppointmentAttribute />} />
    <Route path="new" element={<SurgicalAppointmentAttributeUpdate />} />
    <Route path=":id">
      <Route index element={<SurgicalAppointmentAttributeDetail />} />
      <Route path="edit" element={<SurgicalAppointmentAttributeUpdate />} />
      <Route path="delete" element={<SurgicalAppointmentAttributeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SurgicalAppointmentAttributeRoutes;
